// extracted by mini-css-extract-plugin
export default {"link":"DO-z","disabled":"EO-z"};